import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { ManufacturerResource } from "@exonn/js-sdk";

export const module: ModuleOptions<ManufacturerResource> = {
  resource: ResourceEnum.Manufacturer,
  bigIcon: <i className="icon-20-production" />,
  smallIcon: <i className="icon-15-production" />,
};
